/**
 * Get the dot-notated property on the object.
 *
 * @param {object} obj The object
 * @param {string} prop The property
 * @param {boolean} def default value if prop is not found (or undefined)
 * @returns {object} The value of the property, or undefined if it could not be found.
 */
export default function get(obj, prop, def) {
    var cur = obj;
    var props = prop.split('.');
    var i = 0;
    while (i < props.length && typeof cur === 'object' && cur !== null) {
        cur = cur[props[i++]];
    }
    //explicitly check for undefined because a valid return value could be 0, null, or ""
    if (cur === undefined) {
        return def;
    }
    else {
        return cur;
    }
}
//# sourceMappingURL=get.js.map